/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteDetailContextActionsQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteDetailContextActionsQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly grafanaLink: string | null, readonly scrapbookLink: string | null, readonly urlExclusionList: { readonly __typename?: 'WebsiteUrlExclusionList', readonly rules: ReadonlyArray<string> } } | null };


export const WebsiteDetailContextActionsDocument = gql`
    query WebsiteDetailContextActions($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    grafanaLink
    scrapbookLink
    urlExclusionList {
      rules
    }
  }
}
    `;

/**
 * __useWebsiteDetailContextActionsQuery__
 *
 * To run a query within a React component, call `useWebsiteDetailContextActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteDetailContextActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteDetailContextActionsQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteDetailContextActionsQuery(baseOptions: Apollo.QueryHookOptions<WebsiteDetailContextActionsQuery, WebsiteDetailContextActionsQueryVariables> & ({ variables: WebsiteDetailContextActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteDetailContextActionsQuery, WebsiteDetailContextActionsQueryVariables>(WebsiteDetailContextActionsDocument, options);
      }
export function useWebsiteDetailContextActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteDetailContextActionsQuery, WebsiteDetailContextActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteDetailContextActionsQuery, WebsiteDetailContextActionsQueryVariables>(WebsiteDetailContextActionsDocument, options);
        }
export function useWebsiteDetailContextActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteDetailContextActionsQuery, WebsiteDetailContextActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteDetailContextActionsQuery, WebsiteDetailContextActionsQueryVariables>(WebsiteDetailContextActionsDocument, options);
        }
export type WebsiteDetailContextActionsQueryHookResult = ReturnType<typeof useWebsiteDetailContextActionsQuery>;
export type WebsiteDetailContextActionsLazyQueryHookResult = ReturnType<typeof useWebsiteDetailContextActionsLazyQuery>;
export type WebsiteDetailContextActionsSuspenseQueryHookResult = ReturnType<typeof useWebsiteDetailContextActionsSuspenseQuery>;
export type WebsiteDetailContextActionsQueryResult = Apollo.QueryResult<WebsiteDetailContextActionsQuery, WebsiteDetailContextActionsQueryVariables>;